import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/userGroup.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { UserGroupEffects } from './state/userGroup.effects';

import { UserGroupShellComponent } from './containers/userGroup-shell/userGroup-shell.component';
import { UserGroupListComponent } from './components/userGroup-list/userGroup-list.component';
import { UserGroupEditShellComponent } from './containers/userGroup-edit-shell/userGroup-edit-shell.component';
import { UserGroupEditComponent } from './components/userGroup-edit/userGroup-edit.component';

// Módulo para la ordenación de tablas por columnas.
import { SortableColumnModule } from '../sortableColumn/sortableColumn.module';

@NgModule({
  declarations: [
    UserGroupShellComponent,
    UserGroupEditShellComponent,
    UserGroupListComponent,
    UserGroupEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('userGroups', reducer),
    EffectsModule.forFeature([UserGroupEffects]),
     SortableColumnModule
  ],
  exports: [
    UserGroupListComponent,
    UserGroupEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
     SortableColumnModule
  ]
})
export class UserGroupModule {
  constructor(
  ) {}
}
